import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
import Flow from '../../Assets/Images/leadership-flow.png';
import FlowTwo from '../../Assets/Images/lead-flow-two.png'
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";

const LeadershipFlow360 = () => {
Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

  const styles = StyleSheet.create({
    page: {
      paddingHorizontal: 41,
      paddingVertical: 60,
      backgroundColor: '#FFFFFF',
      justifyContent: "space-between",
      height: '100%'
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderBottom: '1px solid #00577D',
      paddingBottom: 5,
      marginBottom: 2,
      marginTop: '-15px'
    },
    titlemain: {
      fontSize: 12,
      fontWeight: 700,
      color: '#76A3BE',
    },
    title: {
      fontSize: 11,
      fontWeight: 200,
      color: '#76A3BE',
    },
    rightsection: {
      alignItems: 'flex-end',
      flexDirection: 'column',
      flex: 1,
    },
    rightText: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    rightTextsybtext: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    section: {
      marginVertical: 5,
    },
    container: {
      fontFamily: 'Lato',
    },
    headertext: {
      fontSize: 18,
      fontWeight: 700,
      color: '#426B88',
      textAlign: 'center'
    },
    image: {
      width: 164,
      height: 174,
      justifyContent: "space-between"
    },
    paragraph: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 2,
      fontFamily: 'Lato',
    },
    paragraphtopspace: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 2,
      fontFamily: 'Lato',
      marginTop: 2
         },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
    imgsection: {
        display: "flex",
    },
    container: {
        fontFamily: 'Lato',
      },
      headertext: {
        fontSize: 18,
        fontWeight: 700,
        color: '#426B88',
        marginTop: 4,
        textAlign: 'center'
      },
      imgContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
      },
      imgSection: {
        flexDirection: 'column',
        alignItems: 'left',
        marginHorizontal: 10,
      },
      image: {
        width: 164,
        height: 174,
        justifyContent: 'space-between',

      },
      label: {
        fontSize: 12,
        fontWeight: 700,
        color: '#245775',
        marginBottom: 5,
        justifyContent: "flex-start"
      },
      flowimg: {
        marginTop: 5, 
        width: "432px",
        height: "77px",
        alignItems: 'center'
      },
      content: {
        fontSize: 12,
        fontWeight: 700,
        lineHeight: "18px",
        color: '#245775',
        fontFamily: 'Lato',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '0px'
      },
      contentsection: {
        justifyContent: 'center',
        alignItems: 'center'
      }
  });

  return (
    <View style={styles.page}>
      <View>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerleft}>
            <Text style={styles.titlemain}>QUADRANT FLOW</Text>
            <Text style={styles.title}>Life & Leadership Assssment</Text>
          </View>
          <View style={styles.rightsection}>
            <Text style={styles.rightText}>Rob Murray</Text>
            <Text style={styles.rightTextsybtext}>
              Atlas Real Estate{"\n"}Oct 18, 2024
            </Text>
          </View>
        </View>

        {/* Image */}
        <View style={styles.container}>
          <Text style={styles.headertext}>YOUR LEADERSHIP FLOW</Text>
          <View style={styles.imgContainer}>
            <View style={styles.imgSection}>
              <Text style={styles.label}>SELF</Text>
              <Image src={Flow} style={styles.image} />
            </View>
            <View style={styles.imgSection}>
              <Text style={styles.label}>360</Text>
              <Image src={Flow} style={styles.image} />
            </View>
          </View>
        </View>
        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>
            Quadrant Flow is a leadership framework that focuses on the movement
            of energy across four essential quadrants: Mind, Strength, Heart,
            and Soul. Each quadrant reflects a different aspect of leadership:
            the Mind drives strategic thinking, Strength fuels performance and
            action, the Heart fosters collaboration and connection, and the Soul
            represents visionary insight.
          </Text>

          <Text style={styles.paragraphtopspace}>
            Unlike rigid personality assessments, Quadrant Flow emphasizes
            fluidity, showing that leadership flows dynamically between these
            quadrants. The areas where we flow last—often perceived as
            weaknesses—are actually opportunities for growth and development.
            This holistic approach encourages leaders to see potential in every
            quadrant, deepening self-awareness and fostering balanced, effective
            leadership.
          </Text>
        </View>
      </View>
      <View style={styles.contentsection}>
        <Text style={styles.content}>Your Leadership Flow - Self is:</Text>
        <Image src={FlowTwo} style={styles.flowimg} />
        <Text style={styles.content}>Your Leadership Flow - 360 is:</Text>
        <Image src={FlowTwo} style={styles.flowimg} />
      </View>
      {/* Footer Section */}
      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>SELF REPORT</Text>
          <Text style={styles.footerText}>
            © Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by
            Transformational Performance & Transformed Leader. All rights
            reserved.
          </Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>
  );
}

export default LeadershipFlow360;